export const convertUTCtoLocal=(dateString: string): string => {
    const date = new Date(dateString);
    const adjustedDate = new Date(
      date.getTime() - date.getTimezoneOffset() * 60 * 1000
    );
    return adjustedDate.toLocaleString("en-US", { hour12: false });
  }